import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><span
                                                className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">DECISION MAKING STYLES</span>
                                            </div>
                                            <p>If you are confident about your decisions in the past, you
                                                are likely to believe that you made a
                                                good decision and you were competent at the time you made
                                                it. This feeling of confidence that
                                                you have made the right decision is influenced by the way in
                                                which you reached it. For example,
                                                you may feel more confident that you have made the right
                                                decision if you have written down all
                                                of the possible solutions and made a list of pros and cons
                                                for each one before deciding on the
                                                best course of action.
                                            </p>
                                            <p>Everyone has their own preferred decision making style that
                                                enables them to make judgement
                                                calls and important decisions. Your preferred decision
                                                making style can be influenced by many
                                                things, including preparation of information and knowledge
                                                of the topic area. Indeed, it is often
                                                the case that people feel more confident when they know the
                                                subject area or have a strategy for
                                                making the judgement call. However, in order to explore your
                                                confidence in making judgement
                                                calls you need to go a step further and consider your
                                                personality and your preferences. There are
                                                no right or wrong personality types, and different decision
                                                making styles will work better or worse
                                                in different situations. An awareness of your characteristic
                                                preferences or style of making
                                                decisions can give you insight into other perspectives you
                                                might not have considered. Raising
                                                your awareness of other perspectives that may have otherwise
                                                gone unnoticed will give you the
                                                opportunity to consider more options or approach decision
                                                making in another way. This will
                                                provide you with a more thorough approach and help you to
                                                feel more confident that you have
                                                made the right choice.</p>
                                            <p>When making decisions, considering other options, factoring
                                                in what others might feel or think
                                                about the decision can help give you confidence in your
                                                judgements. There will always be people
                                                with different personalities to yourself and those who have
                                                decision making styles different from
                                                yours, but you can build confidence in your decisions and
                                                judgements if you know that you have
                                                considered all the angles.</p>
                                            <p>Understanding your personality profile will help you
                                                recognise how you prefer to make decisions.
                                                From this you can see where your strengths are and where you
                                                need to consider other options.
                                                For example, if you have a low score on Agreeableness you
                                                are likely to be more task focused
                                                than people focused.</p>
                                            <p>This is great in terms of getting a task completed but you
                                                may need to think about how your
                                                decisions will affect other people around you.</p>
                                            <p>It is generally accepted amongst researchers that there are
                                                five broad domains that describe
                                                different aspects of personality.<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>3</sup></a>&nbsp; A
                                                review by McRae &amp; Costa of the 5-factor personality
                                                model
                                                describes high scorers in these factors as follows:</p>


                                            <div
                                                className="lightgreencontentbg keyquestionpad lightbgcenter">
                                                <ul className="greenbullet-list uiheading thought-list-wordbreaknor">
                                                    <li><p><span
                                                        className="green"><strong>Extraversion</strong></span> –
                                                        A strong desire to be involved with others socially,
                                                        participation in team/group events, and ability to
                                                        outwardly display these feelings.</p></li>
                                                    <li><p><span
                                                        className="green"><strong>Openness to Experience</strong></span> –
                                                        Interest in wide range of events such as travel,
                                                        cusine, etc. A need for novelty, change and variety.
                                                    </p></li>
                                                    <li><p><span
                                                        className="green"><strong>Conscientiousness</strong></span> –
                                                        A strong sense of purpose, a striving and
                                                        accomplishment based internal drive, as well as a
                                                        tendency to plan for the long-term rather than
                                                        short-term reward. </p></li>
                                                    <li><p><span
                                                        className="green"><strong>Agreeableness</strong></span> –
                                                        A forgiving and generous nature belief in
                                                        cooperation with others and a desire to avoid
                                                        inter-personal conflict.</p></li>
                                                    <li className="cntareap"><p><span
                                                        className="green"><strong>Neuroticism</strong></span> –
                                                        A worried nature, including low self-esteem,
                                                        self-doubt and perfectionist and
                                                        pessimistic approaches to one’s own actions.</p>
                                                    </li>
                                                </ul>
                                            </div>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}